import * as React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { UserForm } from '../components/UserForm';
import { UserFormData } from '../types';
import { PageHeader } from '@/components/layout/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { UsersService } from '@/services/users-service';

export function AddUserPage() {
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (data: UserFormData) => {
    try {
      setIsLoading(true);
      const newUser = await UsersService.createUser(data);
      toast({
        title: 'Success',
        description: 'User created successfully',
      });
      // Navigate to the user details page
      navigate({ to: `/users/${newUser.id}` });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to create user';
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate({ to: '/users' });
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Add New User"
        description="Create a new user account with appropriate permissions."
      />
      
      <Card>
        <CardContent className="pt-6">
          <UserForm onSubmit={handleSubmit} onCancel={handleCancel} isLoading={isLoading} />
        </CardContent>
      </Card>
    </div>
  );
}
